import React from 'react';
import LandingMediaKitMediaLabProduction from '../TNOMediaKitMediaLabProduction/LandingMediaKitMediaLabProduction';
import {
  harrisonMozoMediaLabWho,
  harrisonMozoMediaLabWhy,
  harrisonMozoMediaLabBenefits,
  harrisonMozoMediaLabValues,
  harrisonMozoMediaLabAreYouReady,
} from '../TNOMediaKitMediaLabProduction/harrisonMozoMediaLabContent';

const LandingMediaKitHarrisonMozo = (props) => (
  <LandingMediaKitMediaLabProduction
    {...props}
    proposalSlug="harrison-mozo"
    mediaLabContent={{
      who: harrisonMozoMediaLabWho,
      why: harrisonMozoMediaLabWhy,
      benefits: harrisonMozoMediaLabBenefits,
      values: harrisonMozoMediaLabValues,
      areYouReady: harrisonMozoMediaLabAreYouReady,
    }}
  />
);

export default LandingMediaKitHarrisonMozo;
